module.exports = __webpack_public_path__ + "static/media/skills.28238f1b.webp";